import React, { createContext, useContext, useEffect, useState } from 'react';
import { useUser } from './userContext';
import { loadVehicleTypes, clearVehicleTypesCache } from '../constants/vehicleTypes';

const VehicleTypesContext = createContext();

/**
 * Provider component that loads and manages vehicle types
 */
export const VehicleTypesProvider = ({ children }) => {
    const { user } = useUser();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadTypes = async () => {
            if (user && user.api_key) {
                setIsLoading(true);
                setError(null);
                try {
                    await loadVehicleTypes(user.api_key);
                } catch (err) {
                    console.error('Failed to load vehicle types:', err);
                    setError(err.message);
                } finally {
                    setIsLoading(false);
                }
            }
        };

        loadTypes();
    }, [user]);

    const refreshVehicleTypes = async () => {
        clearVehicleTypesCache();
        if (user && user.api_key) {
            setIsLoading(true);
            setError(null);
            try {
                await loadVehicleTypes(user.api_key);
            } catch (err) {
                console.error('Failed to refresh vehicle types:', err);
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const value = {
        isLoading,
        error,
        refreshVehicleTypes
    };

    return (
        <VehicleTypesContext.Provider value={value}>
            {children}
        </VehicleTypesContext.Provider>
    );
};

/**
 * Hook to use vehicle types context
 */
export const useVehicleTypes = () => {
    const context = useContext(VehicleTypesContext);
    if (context === undefined) {
        throw new Error('useVehicleTypes must be used within a VehicleTypesProvider');
    }
    return context;
};